import { Actions, createEffect, ofType } from '@ngrx/effects';
import { changeLanguage } from './app.actions';
import { TranslateService } from '@ngx-translate/core';
import { tap } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class AppEffects {
  public changeLanguage$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(changeLanguage),
        tap(({ language }) => {
          this.translateService.use(language);
        }),
      );
    },
    { dispatch: false },
  );

  constructor(
    private actions$: Actions,
    private readonly translateService: TranslateService,
  ) {}
}
